import { Reveal } from "@/components/landing/Reveal";
import { SITE } from "@/config/site";

const LOGOS = {
  "Banmédica": "/img/logos/banmedica.png",
  "Colmena": "/img/logos/colmena.png",
  "Consalud": "/img/logos/consalud.png",
  "Cruz Blanca": "/img/logos/cruz-blanca.png",
  "Esencial": "/img/logos/esencial.png",
  "Nueva Masvida": "/img/logos/nueva-masvida.png",
  "Vida Tres": "/img/logos/vida-tres.png",
};

const Item = ({ name, src }) => (
  <li className="flex h-24 items-center justify-center rounded-2xl border border-[#E3EAEF] bg-white px-5" data-testid={`logo-${name.toLowerCase().replace(/\s/g, "-")}`}>
    {src ? <img src={src} alt={`Logo ${name}`} loading="lazy" className="max-h-12 w-auto max-w-full object-contain" />
      : <span className="text-[20px] font-extrabold tracking-tight text-[#0B3C5D]">{name}</span>}
  </li>
);

export const Insurers = () => (
  <section aria-labelledby="isapres-title" data-testid="insurers-section" className="bg-white py-14 sm:py-16">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <Reveal>
        <h2 id="isapres-title" className="text-center text-[22px] font-bold text-[#0B3C5D] sm:text-[26px]">Te orientamos sobre planes de estas Isapres</h2>
      </Reveal>
      <Reveal delay={0.05}>
        <ul className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4">
          {SITE.isapres.map((n) => <Item key={n} name={n} src={LOGOS[n]} />)}
          <li className="flex h-24 flex-col items-center justify-center gap-1 rounded-2xl border border-dashed border-[#C9D6DF] bg-white px-4 text-center" data-testid="logo-fonasa">
            <span className="text-[14px] font-semibold text-[#4A5864]">¿Vienes de…?</span>
            <img src="/img/logos/fonasa.png" alt="Logo Fonasa" loading="lazy" className="max-h-9 w-auto object-contain" />
          </li>
        </ul>
      </Reveal>
      <p className="mt-6 text-center text-[15px] text-[#4A5864]">Las marcas pertenecen a sus respectivos dueños. Este sitio no es la página oficial de ninguna de ellas.</p>
    </div>
  </section>
);
